import { type FC, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Alert, Flex, Text } from "src/components";
import { Color, FontSize } from "src/theme";
import { useTranslation } from "src/translations";
import { OutageType } from "src/types";
import { setActiveOutageType } from "../actions";
import { getActiveOutageType } from "../selectors";
import { AnnotationItem } from "./AnnotationItem";

export const TableAnnotation: FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const activeOutageType = useSelector(getActiveOutageType);

    const setType = useCallback(
        (type: OutageType) => {
            const newType = type === activeOutageType ? null : type;
            dispatch(setActiveOutageType(newType));
        },
        [activeOutageType, dispatch],
    );

    return (
        <Flex justifyContent="space-between" flexWrap="wrap" gap="1rem">
            <Flex alignItems="center" gap="0.5em">
                <Alert color={Color.red10} clickable={false} />
                <Text size={FontSize._14}>{t("outage.noActiveOutage")}</Text>
            </Flex>
            <Flex justifyContent="flex-end" gap="1.5rem" flexWrap="wrap">
                <AnnotationItem
                    outageType={OutageType.PlannedOutage}
                    isActive={activeOutageType === OutageType.PlannedOutage}
                    onClick={setType}
                />
                <AnnotationItem
                    outageType={OutageType.UnplannedPartialOutage}
                    isActive={activeOutageType === OutageType.UnplannedPartialOutage}
                    onClick={setType}
                />
                <AnnotationItem
                    outageType={OutageType.UnplannedOutage}
                    isActive={activeOutageType === OutageType.UnplannedOutage}
                    onClick={setType}
                />
            </Flex>
        </Flex>
    );
};
